import { BIN_PACKING_READY_QUERY_PARAM } from 'features/cluster/nodes/_constants/query-params';
import { WorkloadBaseRunningInNode } from 'features/cluster/nodes/types';

import {
  ClientSideSearchCriterion,
  makeSearchBoxCriteria,
} from '@cast/shared-search-ui';

export const namespaceCriterion: ClientSideSearchCriterion<WorkloadBaseRunningInNode> =
  {
    key: 'namespace',
    prop: 'namespace',
    matcher: 'exact',
  };

export const workloadTypeCriterion: ClientSideSearchCriterion<WorkloadBaseRunningInNode> =
  {
    key: 'workloadType',
    prop: 'workloadType',
    matcher: 'exact',
  };

const binPackingReadyCriterion: ClientSideSearchCriterion<WorkloadBaseRunningInNode> =
  {
    key: BIN_PACKING_READY_QUERY_PARAM,
    prop: 'migrationStatus',
    title: 'Bin packing ready:',
    matcher: 'exact',
  };

export const criteria = [
  ...makeSearchBoxCriteria<WorkloadBaseRunningInNode>(
    {
      key: 'Workload name:',
      prop: 'name',
      allowMultiple: true,
      matcher: 'exact',
    },
    binPackingReadyCriterion
  ),
  namespaceCriterion,
  workloadTypeCriterion,
];
